module.exports = "\r\napp-jog{\r\n  width: 100%;\r\n}\r\n\r\n.j1{\r\n  top:800px;\r\n}\r\n\r\n.dg{\r\n  position: fixed;\r\n  z-index: 2000;\r\n}\r\n\r\napp-panel2{\r\n  z-index: 3000;\r\n  position: absolute;\r\n  width: 1800px;\r\n  height: 700px;\r\n  top: 400px;\r\n}\r\n\r\napp-panel{\r\n  position: absolute;\r\n  top: 250px;\r\n  left: 200px;\r\n  z-index: 3000;\r\n}\r\n\r\napp-gui{\r\n  top: 250px;\r\n  position: relative;\r\n\r\n}\r\n\r\n.wr{\r\n  width: 10%;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main